import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { BiMap, BiPhone, BiEnvelope } from "react-icons/bi";
import Payment from "../assets/images/payment.png";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../redux/userRedux";

const Footer = () => {
  const user = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const handleLogout = (e) => {
    dispatch(logout());
    navigate("/login")
  }

  return (
    <>
      <section className="footer">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="footer-content">
                <div className="footer-category">
                  <h2 className="footer-category-title">Brand directory</h2>

                  <div className="footer-category-box">
                    <h3 className="category-box-title">Fashion :</h3>

                    <Link to="/" className="footer-category-link">
                      T-shirt
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Shirts
                    </Link>
                    <Link to="/" className="footer-category-link">
                      shorts & jeans
                    </Link>
                    <Link to="/" className="footer-category-link">
                      jacket
                    </Link>
                    <Link to="/" className="footer-category-link">
                      dress & frock
                    </Link>
                    <Link to="/" className="footer-category-link">
                      innerwear
                    </Link>
                    <Link to="/" className="footer-category-link">
                      hosiery
                    </Link>
                  </div>

                  <div className="footer-category-box">
                    <h3 className="category-box-title">footwear :</h3>

                    <Link to="/" className="footer-category-link">
                      sport
                    </Link>
                    <Link to="/" className="footer-category-link">
                      formal
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Boots
                    </Link>
                    <Link to="/" className="footer-category-link">
                      casual
                    </Link>
                    <Link to="/" className="footer-category-link">
                      cowboy shoes
                    </Link>
                    <Link to="/" className="footer-category-link">
                      safety shoes
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Party wear shoes
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Branded
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Firstcopy
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Long shoes
                    </Link>
                  </div>

                  <div className="footer-category-box">
                    <h3 className="category-box-title">jewellery :</h3>

                    <Link to="/" className="footer-category-link">
                      Necklace
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Earrings
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Couple rings
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Pendants
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Crystal
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Bangles
                    </Link>
                    <Link to="/" className="footer-category-link">
                      bracelets
                    </Link>
                    <Link to="/" className="footer-category-link">
                      nosepin
                    </Link>
                    <Link to="/" className="footer-category-link">
                      chain
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Earrings
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Couple rings
                    </Link>
                  </div>

                  <div className="footer-category-box">
                    <h3 className="category-box-title">cosmetics :</h3>

                    <Link to="/" className="footer-category-link">
                      Shampoo
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Bodywash
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Facewash
                    </Link>
                    <Link to="/" className="footer-category-link">
                      makeup kit
                    </Link>
                    <Link to="/" className="footer-category-link">
                      liner
                    </Link>
                    <Link to="/" className="footer-category-link">
                      lipstick
                    </Link>
                    <Link to="/" className="footer-category-link">
                      prefume
                    </Link>
                    <Link to="/" className="footer-category-link">
                      Body soap
                    </Link>
                    <Link to="/" className="footer-category-link">
                      scrub
                    </Link>
                    <Link to="/" className="footer-category-link">
                      hair gel
                    </Link>
                    <Link to="/" className="footer-category-link">
                      hair colors
                    </Link>
                    <Link to="/" className="footer-category-link">
                      hair dye
                    </Link>
                    <Link to="/" className="footer-category-link">
                      sunscreen
                    </Link>
                    <Link to="/" className="footer-category-link">
                      skin loson
                    </Link>
                    <Link to="/" className="footer-category-link">
                      liner
                    </Link>
                    <Link to="/" className="footer-category-link">
                      lipstick
                    </Link>
                  </div>
                </div>
                <div className="footer-nav">
                  <ul className="footer-nav-list">
                    <li className="footer-nav-item">
                      <h2 className="nav-title">Popular Categories</h2>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Fashion
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Electronic
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Cosmetic
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Health
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Watches
                      </Link>
                    </li>
                  </ul>

                  <ul className="footer-nav-list">
                    <li className="footer-nav-item">
                      <h2 className="nav-title">Products</h2>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Prices drop
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        New products
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Best sales
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Contact us
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Sitemap
                      </Link>
                    </li>
                  </ul>

                  <ul className="footer-nav-list">
                    <li className="footer-nav-item">
                      <h2 className="nav-title">Our Company</h2>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Delivery
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Legal Notice
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Terms and conditions
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        About us
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Secure payment
                      </Link>
                    </li>
                  </ul>

                  <ul className="footer-nav-list">
                    <li className="footer-nav-item">
                      <h2 className="nav-title">Services</h2>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/login" className="footer-nav-link">
                        Login
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/register" className="footer-nav-link">
                        Register
                      </Link>
                    </li>

                    {user ? (
                      <li className="footer-nav-item">
                        <p className="footer-nav-link" onClick={handleLogout}>
                          Logout
                        </p>
                      </li>
                    ) : (
                      ""
                    )}

                    <li className="footer-nav-item">
                      <Link to="/reset-password" className="footer-nav-link">
                        Reset Password
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Contact us
                      </Link>
                    </li>

                    <li className="footer-nav-item">
                      <Link to="/" className="footer-nav-link">
                        Sitemap
                      </Link>
                    </li>
                  </ul>

                  <ul className="footer-nav-list">
                    <li className="footer-nav-item">
                      <h2 className="nav-title">Contact</h2>
                    </li>

                    <li className="footer-nav-item flex">
                      <div className="icon-box">
                        <BiMap />
                      </div>

                      <address className="content">
                        Ram Gopal Market Nearest Metro Palam, New Delhi, 110045, INDIA
                      </address>
                    </li>

                    <li className="footer-nav-item flex">
                      <div className="icon-box">
                        <BiPhone />
                      </div>

                      <a href="tel:+918920511882" className="footer-nav-link">
                        (+91) 89205-11882
                      </a>
                    </li>

                    <li className="footer-nav-item flex">
                      <div className="icon-box">
                        <BiEnvelope />
                      </div>

                      <a
                        href="mailto:rohit892051182@gmail.com"
                        className="footer-nav-link"
                      >
                        rohit892051182@gmail.com
                      </a>
                    </li>
                  </ul>

                  {/* <ul className="footer-nav-list">
                    <li className="footer-nav-item">
                      <h2 className="nav-title">Follow Us</h2>
                    </li>

                    <li>
                      <ul className="social-link">
                        <li className="footer-nav-item">
                          <Link to="/" className="footer-nav-link">
                            <ion-icon name="logo-facebook"></ion-icon>
                          </Link>
                        </li>

                        <li className="footer-nav-item">
                          <Link to="/" className="footer-nav-link">
                            <ion-icon name="logo-twitter"></ion-icon>
                          </Link>
                        </li>

                        <li className="footer-nav-item">
                          <Link to="/" className="footer-nav-link">
                            <ion-icon name="logo-linkedin"></ion-icon>
                          </Link>
                        </li>

                        <li className="footer-nav-item">
                          <Link to="/" className="footer-nav-link">
                            <ion-icon name="logo-instagram"></ion-icon>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul> */}
                </div>
                <div className="footer-bottom">
                  <img
                    src={Payment}
                    alt="payment method"
                    className="payment-img"
                  />

                  <p className="copyright">
                    Copyright &copy; <Link to="/">Shop</Link> all rights
                    reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
